<div>
  <div class="form-card">
    <div data-cy="permissions-form-title" class="form-card-header background-teal-sunrise">
      <div class="form-card-title" data-cy="welcome-title-1">Edit permissions</div>
      <ng-container>
        <div class="form-card-subtitle" data-cy="welcome-title-2"></div>
      </ng-container>
    </div>

    <div class="form-card-body background-secondary" data-cy="credentials-container">
      <div class="form-card-body-wrapper flex flex-col items-start m-0" data-cy="admin-permissions-users-container">
        <div class="flex items-center mb-4">
          <mat-form-field class="mr-2" appearance="outline">
            <mat-label>User</mat-label>
            <mat-select (selectionChange)="changeUser($event.value)">
              @for (user of userService.users(); track user) {
                <mat-option [value]="user">{{ user.username }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (showUserSpinner) {
            <mat-spinner class="spinner" diameter="20"></mat-spinner>
          }
        </div>

        @if (selectedUser) {
          <mat-form-field class="mb-4" appearance="outline" id="resourceSelect">
            <mat-label>Resources</mat-label>
            <mat-select [formControl]="resourcesFormControl" multiple>
              @for (resource of resourceService.resources; track resource) {
                <mat-option [value]="resource.id">{{ resource.id }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @for (selectedResource of resourcesFormControl.getRawValue(); track selectedResource) {
          <mat-divider></mat-divider>
          <div class="permission-line-container">
            <p class="mr-6">{{ selectedResource }}</p>

            <mat-form-field appearance="outline" class="mr-4">
              <mat-label>External Source</mat-label>
              <mat-select
                (selectionChange)="externalSourceChange($event.value, selectedResource)"
                #externalSourceSelect
              >
                @for (externalSource of externalSourceList; track externalSource) {
                  <mat-option [value]="externalSource">{{ externalSource }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            @if (externalSourceSelect.value) {
              @switch (resourceEntityMap.get(selectedResource)?.entity?.extSource) {
                @case ('APPLICATIONS') {
                  <ng-container
                    *ngTemplateOutlet="
                      crude;
                      context: {
                        resourceId: selectedResource,
                        entityId: resourceEntityMap.get(selectedResource)?.entity?.id,
                        resourceContainer,
                      }
                    "
                  ></ng-container>
                }
                @case ('TOPOLOGY') {
                  <ng-container
                    *ngTemplateOutlet="
                      lastDropdown;
                      context: {
                        data: developerService.developers,
                        idKey: 'id',
                        labelKey: 'name',
                        source: 'TOPOLOGY',
                        selectedResource,
                        resourceContainer,
                        resourceSelect: externalSourceSelect,
                      }
                    "
                  ></ng-container>
                }
                @case ('IDENTITY_USER') {
                  <ng-container
                    *ngTemplateOutlet="
                      lastDropdown;
                      context: {
                        data: userService.users(),
                        idKey: 'id',
                        labelKey: 'username',
                        source: 'IDENTITY_USER',
                        selectedResource,
                        resourceContainer,
                        resourceSelect: externalSourceSelect,
                      }
                    "
                  ></ng-container>
                }
              }
            }
          </div>
          <div class="resource-set-container flex flex-col items-start mb-4" #resourceContainer>
            @if (userService.groupedPermissions().permissions[toCamelCase(selectedResource)]) {
              <span class="flex items-center">
                {{ selectedResource }} permissions:
                <mat-spinner class="ml-2 permission-spinner" diameter="20"></mat-spinner>
              </span>
              <div class="flex flex-col items-start ml-4 w-full">
                @for (
                  externalSource of userService.groupedPermissions().permissions[toCamelCase(selectedResource)]
                    | keyvalue;
                  track externalSource
                ) {
                  <div class="flex items-center mt-2 mb-2 w-full">
                    <span class="flex resource-set-name mr-2">{{ getEntityLabel(externalSource.key) }}</span>
                    <span class="flex resource-set-values mr-4">{{ externalSource.value }}</span>
                    <button
                      mat-icon-button
                      class="flex resource-set-button mr-2"
                      (click)="
                        deleteEntityFromResource(
                          selectedResource,
                          externalSource.key,
                          deleteSpinner,
                          externalSourceSelect
                        )
                      "
                    >
                      <mat-icon color="primary">delete</mat-icon>
                    </button>
                    <mat-spinner #deleteSpinner class="resource-set-spinner" diameter="20"></mat-spinner>
                  </div>
                }
              </div>
            } @else {
              <span class="flex items-center mt-2 mb-2">
                No permissions set for {{ selectedResource }}
                <mat-spinner class="ml-2 permission-spinner" diameter="20"></mat-spinner>
              </span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #crude let-resourceId="resourceId" let-entityId="entityId" let-resourceContainer="resourceContainer">
  <section class="flex-col ml-4 permissions-container" [formGroup]="getCrudeForm(resourceId)">
    <h4 class="ml-4">Select your permissions:</h4>
    <div class="flex items-start">
      <p class="m-0">
        <mat-checkbox
          #checkboxC
          formControlName="C"
          value="C"
          (change)="togglePermission($event, resourceId, entityId, checkboxC, resourceContainer)"
        >
          C
        </mat-checkbox>
      </p>
      <p class="m-0">
        <mat-checkbox
          #checkboxR
          formControlName="R"
          value="R"
          (change)="togglePermission($event, resourceId, entityId, checkboxR, resourceContainer)"
        >
          R
        </mat-checkbox>
      </p>
      <p class="m-0">
        <mat-checkbox
          #checkboxU
          formControlName="U"
          value="U"
          (change)="togglePermission($event, resourceId, entityId, checkboxU, resourceContainer)"
        >
          U
        </mat-checkbox>
      </p>
      <p class="m-0">
        <mat-checkbox
          #checkboxD
          formControlName="D"
          value="D"
          (change)="togglePermission($event, resourceId, entityId, checkboxD, resourceContainer)"
        >
          D
        </mat-checkbox>
      </p>
      <p class="m-0">
        <mat-checkbox
          #checkboxE
          formControlName="E"
          value="E"
          (change)="togglePermission($event, resourceId, entityId, checkboxE, resourceContainer)"
        >
          E
        </mat-checkbox>
      </p>
    </div>
  </section>
</ng-template>

<ng-template
  #lastDropdown
  let-data="data"
  let-idKey="idKey"
  let-labelKey="labelKey"
  let-source="source"
  let-selectedResource="selectedResource"
  let-resourceContainer="resourceContainer"
  let-resourceSelect="resourceSelect"
>
  @if (resourceSelect.value) {
    <mat-form-field appearance="outline">
      <mat-label>Entity</mat-label>
      <mat-select (selectionChange)="externalSourceChange(source, selectedResource, $event.value)">
        @for (item of data; track item) {
          <mat-option [value]="item[idKey]">{{ item[labelKey] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (resourceEntityMap.get(selectedResource)?.entity?.id) {
      <ng-container
        *ngTemplateOutlet="
          crude;
          context: {
            resourceId: selectedResource,
            entityId: resourceEntityMap.get(selectedResource)?.entity?.id,
            resourceContainer: resourceContainer,
          }
        "
      ></ng-container>
    }
  }
</ng-template>
